import React from 'react';

function Header({
  user,
  onLogout,
  isMenuOpen,
  onToggleMenu,
  onOpenShop,
  onOpenCurrencyPurchase,
  onOpenProfile,
  onNavigate,
  whitelistEnabled = false,
  onWhitelistBlocked,
}) {
  const { name, avatarUrl, runes, sparks } = user || {};

  const faction = user?.side; // 'sun' | 'moon'

const factionIcon =
  faction === 'good'
    ? { emoji: '☀️', label: 'Sun (Good)', color: '#FFD84D' }
    : faction === 'bad'
    ? { emoji: '🌙', label: 'Moon (Bad)', color: '#8B5CF6' }
    : null;


const tryOpenCurrencyPurchase = (which) => {
  if (whitelistEnabled) {
    onWhitelistBlocked?.("shop");
    return;
  }

  if (onOpenCurrencyPurchase) {
    onOpenCurrencyPurchase(which);
    return;
  }

  onOpenShop?.(which);
};

  const level = Math.max(0, Math.min(Number(user?.level) || 0, 30));
const levelPercent = (level / 30) * 100;

function formatCurrencyShort(value) {
  const num = Number(value || 0);

  if (!Number.isFinite(num)) return "0";

  if (num < 1000) {
    return String(Math.floor(num));
  }

  const units = [
    { value: 1_000_000_000, suffix: "B" },
    { value: 1_000_000, suffix: "M" },
    { value: 1_000, suffix: "K" },
  ];

  const unit = units.find((u) => num >= u.value);
  const short = num / unit.value;

  const formatted =
    short >= 100
      ? short.toFixed(0)
      : short >= 10
        ? short.toFixed(1)
        : short.toFixed(1);

  return `${formatted.replace(/\.0$/, "")}${unit.suffix}`;
}
  
  function svgFallback(name = '?') {
  const initial = (name?.[0] || '?').toUpperCase();
  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64">
      <rect width="100%" height="100%" fill="#444"/>
      <text x="50%" y="50%" dominant-baseline="middle"
            text-anchor="middle" font-size="32"
            fill="#fff" font-family="Arial, sans-serif">${initial}</text>
    </svg>`;
  return `data:image/svg+xml;base64,${btoa(svg)}`;
}

  return (

    <header className="header">



      <div className="header-left">
          <button
  type="button"
  onClick={onOpenProfile}
  style={{
    padding: 0,
    border: 0,
    background: "transparent",
    cursor: "pointer",
    width: 36,
    height: 36,
    marginRight: 5
  }}
>
  {avatarUrl ? (
    <img
      src={avatarUrl}
      alt="Avatar"
      className="avatar"
      style={{
        boxSizing: "border-box",
        border: user?.early_bird ? "1px solid #FFD700" : "0px",
        width: 36,
        height: 36,
      }}
    />
  ) : (
    <img
      src={svgFallback(name)}
      alt="Avatar"
      className="avatar"
      style={{
        boxSizing: "border-box",
        border: user?.early_bird ? "1px solid #FFD700" : "0px",
        width: 36,
        height: 36,
      }}
    />
  )}
</button>
        <div className="header_progress" onClick={() => onNavigate?.("home")}>
  <div className="add"></div>

  <div className="current_position">{level}</div>

  <div className="tap_progress">
    <div
      className="position"
      style={{ width: `${levelPercent}%` }}
    ></div>

    <span>{level}/30</span>
  </div>
</div>
      </div>

      <div className="menuright">
        <div className="headerinner" onClick={() => tryOpenCurrencyPurchase("coin_1")}>
          <div className="header_balance csparks"><div className="add"></div>{formatCurrencyShort(sparks)}</div>
        </div>
        
        <div className="headerinner" onClick={() => tryOpenCurrencyPurchase("coin_2")}>
          <div className="header_balance crunes"><div className="add"></div>{formatCurrencyShort(runes)}</div>
        </div>

        <button 
          className="menu-button"
          onClick={onToggleMenu}
        ></button>

      </div>
    </header>
  );
}

export default Header;